export enum UserRoles {
   STUDENT = 'Student',
   TEACHER = 'Teacher',
   SCHOOL_ADMIN = 'School Administrator',
   DISTRICT_ADMIN = 'District Administrator',
   TENANT_ADMIN = 'Tenant Administrator',
   IT_ADMIN = 'IT Administrator',
}
